import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

// Opens a page's create dialog when it is navigated to with ?new=true
// (dashboard quick actions), then strips the param from the URL.
const useNewParam = (openCreate) => {
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (searchParams.get('new') === 'true') {
      openCreate();
      const next = new URLSearchParams(searchParams);
      next.delete('new');
      setSearchParams(next, { replace: true });
    }
    // Run once on mount — the param is consumed and removed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useNewParam;
